import {gsap} from 'gsap';
import {ScrollToPlugin} from 'gsap/dist/ScrollToPlugin';
import IntersectableComponent from './intersectable-component';

gsap.registerPlugin(ScrollToPlugin);


class SectionsMenu extends IntersectableComponent {

	constructor({
		root,
		element,
		intersectingAttribute = 'section',
		intersectingColorSchemeAttribute = 'sectionColorScheme',
		intersectingTypeAttribute = 'sectionType',
		threshold = 0,
		invertedClass = 'inverted',
		selectedClass = 'selected',
		invertedValue = 'inverted',
		linkPrefix = '',
		duration = 1.5
	}) {
		super({
			root: root,
			element: element,
			intersectingAttribute: intersectingAttribute,
			intersectingColorSchemeAttribute: intersectingColorSchemeAttribute,
			threshold: threshold
		});
		this.intersectingTypeAttribute = intersectingTypeAttribute;
		this.defaults.duration = duration;
		this.invertedClass = invertedClass;
		this.selectedClass = selectedClass;
		this.invertedValue = invertedValue;
		this.linkPrefix = linkPrefix;
		this.prevSelected = null;
	}


	prepare() {
		super.prepare();
		this.duration = this.dataAttr().get('duration');
		this.listeners.click = this.events.on(this.element, '[href^="#"]', 'click', this.onLinkClick.bind(this));
	}


	onLinkClick(event, target) {
		event.preventDefault();
		const href = target.getAttribute('href');
		gsap.to(window, {duration: this.duration, scrollTo: {y: href, autoKill: false}, onComplete: () => {
			this.updateHistory(href);
		}});

	}


	toggleIntersection(intersectingElement) {
		const targetDataAttr = this.dataAttr(intersectingElement);
		const sectionId = targetDataAttr.get(this.intersectingAttribute, '');
		const sectionType = targetDataAttr.get(this.intersectingTypeAttribute, '');
		const colorScheme = targetDataAttr.get(this.intersectingColorSchemeAttribute, '');
		this.classList().toggle(this.invertedClass, colorScheme === this.invertedValue);
		this.dataAttr().set(this.intersectingTypeAttribute, sectionType);
		if (this.selectedLink) {
			this.classList(this.selectedLink).remove(this.selectedClass);
		}
		this.selectedLink = this.element.querySelector('[href="#' + this.linkPrefix + sectionId + '"]');
		if (this.selectedLink) {
			this.classList(this.selectedLink).add(this.selectedClass);
			// this.updateHistory(this.selectedLink.getAttribute('href'));
		}
	}


	updateHistory(href) {
		history.replaceState(undefined, undefined, href);
	}

}

export default SectionsMenu;
